import { toLongDate } from './date'

type Translate = (key?: string) => string

/** Nazwa przedmiotu objetego kaucja - pilot wydany ma wlasna nazwe, inaczej metoda otwierania */
export const getDepositItemName = (item?: warehouse.UserDepositItem) => {
  return item?.remoteControlName || item?.openingMethodName
}

/**
 * Komunikat o warunku zwrotu kaucji.
 * `requiresItemReturn` nie da sie wywnioskowac z `kind` - bierzemy `returnState` z backendu.
 */
export const getDepositReturnStateText = (
  { returnState, refundDate, item }: warehouse.UserDeposit,
  t: Translate,
  lang: Intl.LocalesArgument
) => {
  switch (returnState) {
    case 'awaiting_item': {
      const itemName = getDepositItemName(item)
      return itemName
        ? `${t('depositReturnState.awaiting_item')}: ${itemName}`
        : t('depositReturnState.awaiting_items')
    }
    case 'refunded':
      return `${t('depositReturnState.refunded')}${refundDate ? ` ${toLongDate(refundDate, lang, true)}` : ''}`
    default:
      return t(`depositReturnState.${returnState}`)
  }
}

/** Suma kaucji do zwrotu - z podsumowania backendu, a gdy go nie ma, z pozycji listy */
export const getActiveDepositsAmount = (
  deposits?: warehouse.UserDeposit[],
  summary?: warehouse.UserDepositsSummary
) => {
  if (summary?.active !== undefined) return Number(summary.active)
  return (deposits || []).reduce((sum, { isRefunded, amount }) => isRefunded ? sum : sum + Number(amount || 0), 0)
}
